import React, { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import socket from "./socket";

const Main = (props) => {
  const roomRef = 1;
  const userRef = useRef();
  const [err, setErr] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  var roomNoFromSF = useParams(); //queryParams.get('roomid');
  //const { roomNoFromSF1 } = useParams();
  useEffect(() => {
    socket.on("FE-error-user-exist", ({ error }) => {
      if (!error) {
        const roomName = 1;
        const userName = userRef.current.value;

        sessionStorage.setItem("user", userName);
        props.history.push(`/room/${roomName}`);
      } else {
        setErr(error);
        setErrMsg("User name already exist");
      }
    });
  }, [props.history]);

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return typeof sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };

  function clickJoin() {
    roomNoFromSF = getUrlParameter("roomid");
    const roomName = roomRef;
    const userName = userRef.current.value;

    if (!roomName || !userName) {
      setErr(true);
      setErrMsg("Enter Room Name or User Name");
    } else {
      socket.emit("BE-check-user", { roomId: roomName, userName: userName });
    }
  }
  // console.log(userRef.current.value);
  return (
    <AppContainer>
      <MainContainer>
        <Row>
          <Label htmlFor="roomName">Room Name</Label>
          <Input
            type="text"
            id="roomName"
            // ref={roomRef}
            value={roomRef}
            // value={roomNoFromSF}
            readOnly
            // hidden
          />
        </Row>
        <Row>
          <Label htmlFor="userName">User Name</Label>
          <Input type="text" id="userName" ref={userRef} />
        </Row>
        <JoinButton onClick={clickJoin}> Join </JoinButton>
        {err ? <Error>{errMsg}</Error> : null}
      </MainContainer>
    </AppContainer>
  );
};

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 15px;
  line-height: 35px;
`;

const Label = styled.label``;

const Input = styled.input`
  width: 150px;
  height: 35px;
  margin-left: 15px;
  padding-left: 10px;
  outline: none;
  border: none;
  border-radius: 5px;
`;

const Error = styled.div`
  margin-top: 10px;
  font-size: 20px;
  color: #e85a71;
`;

const JoinButton = styled.button`
  height: 40px;
  margin-top: 35px;
  outline: none;
  border: none;
  border-radius: 15px;
  color: #07233f;
  background-color: #01d6c0;
  font-size: 25px;
  font-weight: 500;

  :hover {
    background-color: #7bb1d1;
    cursor: pointer;
  }
`;

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(8px + 2vmin);
  color: #07233f;
  background-color: #eaeceb;
  text-align: center;
  border-radius: 20px 20px 0 0;
  height: 100vh;
  width: 100%;
  object-fit: cover;
`;
//20px 20px 0 0;
export default Main;
